export interface RequestableApproverConstructor {
  id: number
  threshold: number
  userId: number
  email: string
  firstName: string
  lastName: string
  profileImage: string
}

export class RequestableApprover {
  id: number
  threshold: number
  userId: number
  email: string
  firstName: string
  lastName: string
  profileImage: string

  constructor(data: RequestableApproverConstructor) {
    this.id = data.id
    this.threshold = data.threshold
    this.userId = data.userId
    this.email = data.email
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.profileImage = data.profileImage
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }
}
